import { Alert } from 'react-bootstrap';
import { Modal } from '../../../../common/components/modals';
import { useLiquidatedOvertimeHours } from '../../hooks/useLiquidatedOvertimeHours';
import { LiquidatedOvertimeHourModel } from '../../models/liquidateOvertimeHours';
import { toast } from 'react-toastify';
import { ApproveLiquidatedOvertimeHoursRequest } from '../../models/requests';
import { useState } from 'react';
import OvertimeReasonsSelector from '../../../overtime-reasons/components/OvertimeReasonsSelector';

export interface ApproveOverTimesModalProps {
    isOpen: boolean;
    onClose: () => void;
    reHidrate: () => Promise<void>;
    data: LiquidatedOvertimeHourModel[];
}

export const ApproveOverTimesModal = ({
    data,
    isOpen,
    onClose,
    reHidrate,
}: ApproveOverTimesModalProps) => {
    const [errorMessage, setErrorMessage] = useState('');
    const [commentsValue, setCommentsValue] = useState('');
    const [overtimeReasonId, setOvertimeReasonId] = useState<number>(0); 

    const { approveOvertimeHours, isLoading } = useLiquidatedOvertimeHours();

    const handlerSubmit = async () => {
        if (!commentsValue?.trim()) {
            setErrorMessage('Es necesario ingresar una observación.');
            return;
        }

        if (!overtimeReasonId) {
            setErrorMessage('Es necesario seleccionar un motivo de aprobación.');
            return;
        }
        
        try {
            const request: ApproveLiquidatedOvertimeHoursRequest = {
                comments: commentsValue,
                overtimeReasonId: overtimeReasonId,
                preliquidationHourSummaryIds: data.map(
                    (d) => d.preliquidationHourSummaryId
                ),
            };
            const response = await approveOvertimeHours(request);

            if ([400, 500, 404].includes(response?.response?.status)) {
                toast.error(response?.response?.data ??  'Ocurrió un error al aprobar las horas extras');
                setErrorMessage(response?.response?.data ?? 'Ocurrió un error al aprobar las horas extras');
            } else {
                toast.success('Se aprobaron las horas extras correctamente');
                setErrorMessage('');
                onClose();
                reHidrate();
            }
        } catch (error) {
            toast.error('Ocurrió un error al aprobar las horas extras');
            setErrorMessage('Ocurrió un error al aprobar las horas extras');
        }
    };

    return (
        <Modal
            isOpen={isOpen}
            modalTitle='Aprobar horas extras seleccionadas'
            disableSubmit={data?.length == 0 || isLoading}
            onSubmit={handlerSubmit}
            onClose={onClose}
            widthCustom='500px'
        >
            <div className='my-3'>
                {!isLoading && errorMessage !== '' && (
                    <Alert variant='danger'>{errorMessage}</Alert>
                )}
                <label htmlFor={'comments'} className='form-label form-label'>
                    Comentarios
                </label>
                <textarea
                    className='form-control text-dark'
                    id='comments'
                    data-lt-tmp-id='lt-465430'
                    onChange={(e) => setCommentsValue(e.target.value)}
                    spellCheck={false}
                    data-gramm='false'
                ></textarea>
            </div>
            <div className='my-3'> 
                <OvertimeReasonsSelector 
                    name="overtimeReasonId"
                    label="Razon de aprobación"
                    value={overtimeReasonId}
                    onChange={(_, v) => setOvertimeReasonId(v)}
                    required={true}
                /> 
            </div> 
        </Modal>
    );
};
